import React from "react";
import Select from "react-select";
const MultiselectInput = ({
  input,
  meta,
  schemaProps: { machine_name, choice, value, checked, disabled },
  ...rest
}) => {
  /*choice should be in below format
        [{ value: 'local', label: 'local' },
         { value: 'state', label: 'state' },
         { value: 'federal', label: 'federal' },]*/
  return (
    <div>
      <Select
        {...input}
        id={machine_name}
        name={machine_name}
        isDisabled={(disabled)?(!disabled):false}
        options={choice}
        isMulti={true}
        isSearchable={true}
      />
    </div>
  );
};

export default MultiselectInput;
